import { useStyletron } from 'baseui';
import { ListItemLabel } from 'baseui/list';
import { DateTime } from 'luxon';
import { COLOURS } from '@gtintel/platform-utils';
import DatePill from '../../components/DatePill';
import { RequestStatusPill } from '../../components/RequestStatusIcon';
export default ({
  assignment,
  status
}) => {
  const [css] = useStyletron();
  return <div data-testid={`assignment-${assignment.id}`} className={css({
    display: 'grid',
    gap: '16px',
    gridTemplateColumns: '3fr minmax(180px, .5fr)',
    padding: '14px 0',
    width: '100%',
    '@media (max-width: 768px)': {
      gridTemplateColumns: '2fr 1.5fr'
    }
  })}>
      <div className={css({
      alignItems: 'center',
      display: 'flex',
      flexFlow: 'row nowrap',
      justifyContent: 'space-between',
      '@media (max-width: 768px)': {
        alignItems: 'flex-start',
        flexFlow: 'column nowrap',
        gap: '16px'
      }
    })}>
        <div>
          {assignment.is_lead_partner_assignment && <small>Lead Assignment</small>}
          {assignment.is_qa_assignment && <small>QA Assignment</small>}
          <ListItemLabel overrides={{
          LabelRoot: {
            style: {
              padding: '0'
            }
          }
        }}>
            {assignment.name ?? `Assignment #${assignment.id}: ${assignment.project.name}`}
          </ListItemLabel>
        </div>
        <div className={css({
        display: 'flex',
        flexFlow: 'row nowrap',
        gap: '8px',
        '@media (max-width: 480px)': {
          flexDirection: 'column'
        }
      })}>
          <span>
            <strong>Last Updated:</strong>{' '}
            <DatePill date={DateTime.fromISO(assignment.updated_at).toISODate()} colour={COLOURS.orange} title={DateTime.fromISO(assignment.updated_at).toRelative()} />
          </span>
          <span>
            <strong>Due: </strong>
            <DatePill date={DateTime.fromISO(assignment.due_date).toISODate()} colour={COLOURS.blue} />
          </span>
        </div>
      </div>
      <div className={css({
      justifySelf: 'flex-end',
      display: 'flex',
      justifyContent: 'flex-end'
    })}>
        <RequestStatusPill status={status} />
      </div>
    </div>;
};